
export class UserNotificationCounter {

  constructor(
    public counter?: number
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/user-notification-counter.ts